import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Portfolio.css';

function Portfolio() {
  const { t } = useTranslation();

  return (
    <section className="portfolio-section">
      <Container>
        <div className="portfolio-header text-center mb-5">
          <h4 className="portfolio-subtitle">{t('portfolio.portfolioInMotion')}</h4>
          <h3 className="portfolio-title">{t('portfolio.seeTransformation')}</h3>
        </div>
        
        <div className="portfolio-video-container">
          <div className="portfolio-video-wrapper">
            <div 
              className="portfolio-video-background"
              style={{ 
                backgroundImage: `url("https://lh3.googleusercontent.com/aida-public/AB6AXuDMZ6kNCgyP7yDjnJDgs15gXQRmY1HCP5AzyjDUi3Nk9bUB2s5yzwf5-gtCjFN1YEb7m1UJiVOOe7Ucdf3SK-Dfvcu1VaaRoe3tiBlCtJphbdjp_b_i8LQXXiby0lSk4ipLHfn9_tNmJEETPj7dZnPhW4dXSZFnZCZh0U6aUBASB0AjOO8ztz_XgT4f4ZBf9IwQqMwDvYb4KZnT0I67fuTpHPXYK0CUy-jTOwkINuVYeBKCGOcxWTc3kkovyqYuW0ezG6S8WToIl4_o")` 
              }}
            ></div>
            <div className="portfolio-video-overlay">
              <div className="portfolio-play-button">
                <span className="material-symbols-outlined">play_arrow</span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Portfolio;
